import { format } from '@eika-infrastruktur/date';
import { truncateName } from '@eika-infrastruktur/format';

import type { Approver } from '../../../generated-types';

const getCurrentApproverString = (approver: Approver) => {
    if (approver.dateOfApproval) {
        return `${truncateName(approver.name)}, ${format(approver.dateOfApproval, 'dd.MM.yy')}`;
    }

    return truncateName(approver.name);
};

const composeApprovedByString = (approvedBy: Approver[]) => {
    const mapped = approvedBy.map(getCurrentApproverString);
    if (approvedBy.length > 1) {
        const lastEntry = mapped.pop();
        const joined = mapped.join(', ');
        return `${joined} og ${lastEntry}`;
    }
    return mapped.join(', ');
};

export default composeApprovedByString;
